// extracted by mini-css-extract-plugin
export default {"qrcode":"index_qrcode_5CZ8a","qrcodeItem":"index_qrcodeItem_7DZFg","qrcodePic":"index_qrcodePic_NSrbD","qrcodeText":"index_qrcodeText_6Rgf-"};